<div class="card card-info card-outline">
    <div class="card-header">
      <h3 class="card-title"><i class="fas fa-users"></i> ข้อมูลพนักงาน</h3>
      <div class="card-tools text-primary ">
        <button type="button" class="btn btn-tool" data-card-widget="collapse">
          <i class="fas fa-minus"></i>
        </button>
      </div>
    </div>
    <div class="card-body">
        table
    </div>
  </div>

